import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";

import ToolBar from "../../Components/Activites/ToolBar/ToolBar";
import LeftBar from "../../Components/Activites/LeftBar/LeftBar";
import ActivityPosts2 from "../../Components/Activites/AcitvityPosts/ActivityPosts2";
import ActivityPosts from "../../Components/Activites/AcitvityPosts/AcitvityPosts";
import * as actionCreator from "../../Store/actions/index";
import classes from "./Activites.module.css";
// import Spinner from "../../Components/UI/Spinner/Spinner";
import PaymentHistory from "../../Components/Activites/AcitvityPosts/PaymentHistory/PaymentHistory";
import Invoices from "../../Components/Activites/AcitvityPosts/Invoices/Invoices";
import Paggination from "../../Components/UI/Paggination/Paggination";
import ModelOptions from "../../Components/Activites/ModelOption/ModelOption";
import SubModelOption from "../../Components/Activites/ModelOption/SubModel";

class Activites extends Component {
  state = {
    activityMode: "post",
    postMode: "published",
    model: "all",
    modelTitle: "all",
    showSubModel: false,
    subModel: null,
  };

  componentDidMount() {
    this.props.onGetActivityPosts(this.state.model, this.state.postMode);
  }

  componentDidUpdate(prevProp, prevState) {
    if (
      prevState.activityMode !== this.state.activityMode ||
      prevState.postMode !== this.state.postMode
    ) {
      switch (this.state.activityMode) {
        case "post":
          //Get published POsts
          this.props.onGetActivityPosts(this.state.model, this.state.postMode);
          break;
        case "paymentHistory":
          //GET Pymetn Histpry:
          this.props.onGetPaymentHistory();
          break;
        case "invoices":
          //Do some Thing
          this.props.onGetInvoices();
          break;
        default:
          //Get published POsts
          break;
      }
    }
  }

  modelOptionHandler = (model, modelTitle) => {
    if (model.includes("all") && model !== "all_apparels_merchandises") {
      this.setState({ showSubModel: true });
    } else {
      this.setState({ showSubModel: false });
    }
    this.setState({ model: model, modelTitle: modelTitle, subModel: null });
    this.props.onGetActivityPosts(model, this.state.postMode);
  };

  subModelHandler = (subModel) => {
    if (this.state.model === "all_vehicles") {
      this.setState({ showSubModel: true, subModel: subModel });
      this.props.onGetActivityPosts(subModel + "s", this.state.postMode);
    } else if (
      this.state.model.includes("all") &&
      this.state.model !== "all_apparels_merchandises"
    ) {
      subModel = this.state.model.replace("all", subModel);
      this.setState({ showSubModel: true, subModel: subModel });
      this.props.onGetActivityPosts(subModel, this.state.postMode);
    }
  };

  activityModeHandler = (mode) => this.setState({ activityMode: mode });

  postModeHandler = (mode) => this.setState({ postMode: mode });

  render() {
    let activityMode = null,
      paggination = null,
      model = this.state.model;
    if (this.state.showSubModel && this.state.subModel) {
      model = this.state.subModel;
    }
    if (this.props.activityPosts) {
      paggination = (
        <Paggination
          model={model}
          paggination={this.props.activityPosts}
          mode={this.state.postMode}
        />
      );
    }
    switch (this.state.activityMode) {
      case "post":
        activityMode = (
          <Fragment>
            <LeftBar
              postModeHandler={this.postModeHandler}
              postMode={this.state.postMode}
            />
            <ModelOptions
              setModel={this.modelOptionHandler}
              model={this.state.model}
              mode={this.state.postMode}
              modelTitle={this.state.modelTitle}
            />
            <SubModelOption
              showSubModel={this.state.showSubModel}
              modelTitle={this.state.modelTitle}
              model={this.state.subModel}
              setSubModel={this.subModelHandler}
            />
            {this.props.loadingGetActPosts ? (
              <div className="text-center">
                <Spinner variant="primary" animation="grow" />
              </div>
            ) : (
              <>
                {/* <ActivityPosts
                  posts={this.props.activityPosts}
                  postState={this.state.postMode}
                /> */}
                <ActivityPosts2
                  posts={this.props.activityPosts}
                  postState={this.state.postMode}
                  vType={this.props.model}
                />
              </>
            )}
          </Fragment>
        );
        break;
      case "paymentHistory":
        activityMode =
          !this.props.paymentHistory || this.props.loadingPaymentHistory ? (
            <div className="text-center">
              <Spinner variant="primary" animation="grow" />
            </div>
          ) : (
            <PaymentHistory paymetnHistory={this.props.paymentHistory} />
          );
        break;
      case "invoices":
        activityMode =
          this.props.loadingInvoices || !this.props.invoices ? (
            <div className="text-center">
              <Spinner variant="primary" animation="grow" />
            </div>
          ) : (
            <Invoices invoices={this.props.invoices} />
          );
        break;
      default:
        break;
    }
    return (
      <Fragment>
        <h1 className="ModelHeadline mt-5">ACTIVITES</h1>
        <ToolBar
          activityModeHandler={this.activityModeHandler}
          activityMode={this.state.activityMode}
        />
        <div className={classes.Wraper}>{activityMode}</div>
        {paggination}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loadingGetActPosts: state.Activity.loadingGetActPosts,
    activityPosts: state.Activity.activityPosts,
    activityError: state.Activity.activityError,
    //Payment History:
    loadingPaymentHistory: state.Activity.loadingPaymentHistory,
    paymentHistory: state.Activity.paymentHistory,
    pymentHistoryError: state.Activity.pymentHistoryError,
    //Invoices:
    loadingInvoices: state.Activity.loadingInvoices,
    invoices: state.Activity.invoices,
    invoicesError: state.Activity.invoicesError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetActivityPosts: (model, mode) => {
      dispatch(actionCreator.getActivityPosts(model, mode));
    },
    onGetPaymentHistory: () => {
      dispatch(actionCreator.getPaymentHistory());
    },
    onGetInvoices: () => {
      dispatch(actionCreator.getInvocices());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Activites);
